// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__U4KxX","Link":"StickyAlert_Link__7tLSf","CloseButton":"StickyAlert_CloseButton__jINv8"};